import { render, staticRenderFns } from "./PitchDayAvaliacao.vue?vue&type=template&id=c368b488&scoped=true"
import script from "./PitchDayAvaliacao.vue?vue&type=script&lang=js"
export * from "./PitchDayAvaliacao.vue?vue&type=script&lang=js"
import style0 from "./PitchDayAvaliacao.vue?vue&type=style&index=0&id=c368b488&prod&scoped=true&lang=css"
import style1 from "./PitchDayAvaliacao.vue?vue&type=style&index=1&id=c368b488&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c368b488",
  null
  
)

export default component.exports